//Harshada Bhavsar(4/7/2025)
//AuthController API for Employee Login with email and password, Verify Token API, Logout API
import axios from "../axios";
import Cookies from "js-cookie";
export const loginEmployee = async (email, password) => {
	return axios.post("/api/Auth/Employee/Login", { email, password });
};

export const verifyEmployeeOtp = async (verificationCode, authUID) => {
  return axios.post("/api/Auth/VerifyEmployeeAuth", {
    verificationCode,
    authUID,
  });
};

export const verifyToken = async (token) => {
	return axios.post("/api/Auth/Employee/Verify", {
		Token: token
	});
};

// --Sanket Raut--
//Consultant Login
export const Consultantlogin = async (email, password) => {
	return axios.post("/api/Auth/Consultant/Login", { email, password });
};

export const verifyConsultantOtp = async (verificationCode, authUID) => {
  return axios.post("/api/Auth/VerifyConsultantAuth", {
    verificationCode,
    authUID,
  });
};

// --Shyama Panda--
//Get Employee Name
export const GetEmployeeName = async (Token) => {
	return axios.post("/api/Auth/Employee/Verify", { Token });
};

// --Sanket Raut--
export const LogoutEmp = async (userTokenExpiry) => {
  const token = Cookies.get("employeeToken");
 
  return axios.post("/api/Auth/Employee/Logout", {
    token,userTokenExpiry
  });
};
 
 
// --Sanket Raut--
export const LogoutConsultant = async () => {
  const token = Cookies.get("ConsultantToken");
 
};
 